
/**
 * Module dependencies.
 */

import { Loading } from './loading';
import { ReactNode } from 'react';
import { ifProp } from 'styled-tools';
import { media } from 'react-components/styles';
import styled, { css } from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode;
  className?: string;
  emptyMessage?: ReactNode;
  isLoading?: boolean;
  isText?: boolean;
  total: number;
};

/**
 * `Rows` styled component.
 */

const Rows = styled.div.attrs({ role: 'rowgroup' })<{ isLoading: boolean; isText: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  row-gap: 12px;

  ${media.min('ms')`
    grid-auto-rows: 1fr;
  `}

  ${ifProp('isLoading', css`
    min-height: ${ifProp('isText', '10vh', '30vh')};

    ${media.min('md')`
      min-height: ${ifProp('isText', '10vh', '50vh')};
    `}
  `)}
`;

/**
 * Export `DataGrid` component.
 */

export function DataGrid(props: Props): JSX.Element {
  const { children, className, emptyMessage, isLoading = false, isText = false, total } = props;

  return (
    <Rows
      className={className}
      isLoading={isLoading}
      isText={isText}
    >
      {total === 0 && !isLoading && emptyMessage}

      <Loading active={isLoading} />

      {!isLoading && total > 0 && children}
    </Rows>
  );
}
